import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { fetchBasket } from "../../services/basket/actions";
import {
  changeDeliveryOptionBody,
  changeProductgroup,
  changeSupplier,
} from "../../services/currentInformation/actions";
import { fetchDeliveryDates } from "../../services/delivery/actions";

const REDIRECT_URL = "https://easy-dish-pimnijhuis.vercel.app/#/orderhistory";

function scheduleDelivery(props) {
  const [chosenDate, setChosenDate] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  let history = useHistory();

  useEffect(() => {
    props.fetchDeliveryDates(props.currentLocation.id, props.userId);
  }, []);

  useEffect(() => {
    props.fetchDeliveryDates(props.currentLocation.id, props.userId);
  }, [props.currentLocation.id]);

  const handleChange = (event) => {
    setChosenDate(event.target.value);
  };

  const handleChangeCheckBox = (event) => {
    setIsChecked(!isChecked);
  };

  const createBodyZakelijk = (id, chosenDate, pay_online) => {
    let body = {};
    if (pay_online) {
      body = {
        location: id,
        deliveryDate: chosenDate,
        redirect_url: REDIRECT_URL,
      };
    } else {
      body = {
        location: id,
        deliveryDate: chosenDate,
      };
    }
    return body;
  };

  return (
    <div align="center">
      <h3>Kies afleverdatum:</h3>
      <FormControl component="fieldset">
        <h4>Voor: {props.currentLocation.name}</h4>
        <RadioGroup
          aria-label="gender"
          name="gender1"
          value={chosenDate}
          onChange={handleChange}
          align="left"
        >
          {props.deliveryDates?.map((date) => (
            <FormControlLabel
              value={date.date}
              control={<Radio color="primary" />}
              label={date.say}
            />
          ))}
        </RadioGroup>
      </FormControl>

      <br />
      <br />
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            checked={isChecked}
            onChange={handleChangeCheckBox}
            inputProps={{ "aria-label": "primary checkbox" }}
          />
        }
        label="Bevestig uw afleverdatum"
      />

      <br />

      <br />
      {isChecked && (
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            // 	history.push({
            // 		pathname: "/confirmorder",
            // 		state: {
            // 			orderBody: createBodyZakelijk(
            // 				props.currentLocation.id,
            // 				chosenDate,
            // 				props.payOnline
            // 			),
            // 			locationName: props.currentLocation.name,
            // 		},
            // 	});
            // };
            props.changeDeliveryOptionBody({
              orderBody: createBodyZakelijk(
                props.currentLocation.id,
                chosenDate,
                props.payOnline
              ),
              locationName: props.currentLocation.name,
            });
            history.push("/confirmorder");
          }}
        >
          Volgende stap
        </Button>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  deliveryDates: state.deliveryDates.deliveryDates,
  userId: state.login.data.user_id,
  payOnline: state.login.data.pay_online,
  locationsList: state.login.data.all_locations,
  currentLocation: state.currentInformation.current_location,
  basketProducts: state.basket.products,
});

export default connect(mapStateToProps, {
  fetchDeliveryDates,
  changeProductgroup,
  changeSupplier,
  fetchBasket,
  changeDeliveryOptionBody,
})(scheduleDelivery);
